export default __webpack_public_path__ + "static/media/My_Picture.fb4f41eb.jpg";